import { IPagination } from "src/app/shared/models/page.model";
import { ICatalog, ICatalogFilterState } from "../models/catalogs.models";
import { Action, createReducer, on } from "@ngrx/store";
import * as catalogsActions from "./catalogs.actions"
import { IProduct } from "../../produits/models/products.models";
import { ICustomer } from "../../customers/models/customers.models";
import { refillCatalogsFilter } from "src/app/shared/utils/helpers";
import { DisablePricebooksSuccess, EnablePricebooksSuccess, TogglePricebookForCatalogSuccess } from "../../pricebook/store/pricebook.actions";
export interface CatalogsState {
  metadata: IPagination | null;
  catalogs: ICatalog[];
  allCatalogs: ICatalog[];
  catalog: ICatalog | null;
  loading: boolean;
  locationCatalogs: ICatalog[];
  products: IProduct[];
  productsMetadata: IPagination | null;
  catalogsFilterState: ICatalogFilterState;
  // Catalog Audience - companies assigned to a specific catalog (edit mode)
  audienceCompanies: ICustomer[];
  audienceMetadata: IPagination | null;
  // Available Companies - all companies for selection (selection dialog)
  availableCompanies: ICustomer[];
  availableCompaniesMetadata: IPagination | null;
}

export const initialProductsState: CatalogsState = {
  metadata: null,
  catalogs: [],
  allCatalogs: [],
  catalog: null,
  loading: false,
  locationCatalogs: [],
  products: [],
  productsMetadata: null,
  catalogsFilterState: {
    advanced: refillCatalogsFilter(),
    keyword: ''
  },
  audienceCompanies: [],
  audienceMetadata: null,
  availableCompanies: [],
  availableCompaniesMetadata: null,
}

const featureReducer = createReducer(
  initialProductsState,
  on(
    catalogsActions.FetchAllCatalogsSuccess,
    (state, action) => ({
      ...state,
      allCatalogs: action.catalogs.data,
    })
  ),
  on(
    catalogsActions.FetchCatalogsSuccess,
    (state, action) => ({
      ...state,
      catalogs: action.catalogs.data,
      metadata: action.catalogs.metadata
    })
  ),
  on(catalogsActions.AddCatalogSuccess, (state, action) => ({
    ...state,
    allCatalogs: [...state.allCatalogs, action.catalog as ICatalog],
  })),
  on(catalogsActions.SetCatalogLoader, (state, action) => ({
    ...state,
    loading: action.isLoading
  })),
  on(catalogsActions.FetchAllCompanyCatalogsByIdSuccess, (state, action) => ({
    ...state,
    locationCatalogs: action.companyCatalogsById,
  })),
  on(catalogsActions.ClearCatalog, (state) => ({
    ...state,
    catalog: null,
  })),
  on(catalogsActions.GetCatalogByIdSuccess, (state, action) => ({
    ...state,
    catalog: action.catalog,
  })),
  on(catalogsActions.GetCatalogProductsSuccess, (state, action) => ({
    ...state,
    products: action.products,
    productsMetadata: action.metadata || null,
  })),
  on(catalogsActions.LoadMoreCatalogProductsSuccess, (state, action) => ({
    ...state,
    products: [...state.products, ...action.products],
    productsMetadata: action.metadata || null,
  })),
  on(catalogsActions.GetProductsCatalogCompanyByIddSuccess, (state, action) => ({
    ...state,
    products: action.products,
  })),
  on(
    catalogsActions.SetCatalogLoader,
    (state, action) => ({
      ...state,
      loading: action.isLoading
    })),
  on(catalogsActions.SetCatalogsFilter, (state, action) => ({
    ...state,
    catalogsFilterState: {
      keyword: action.keyword,
      advanced: action.advanced!
    }
  })),
  on(catalogsActions.SetCatalogsSearch, (state, action) => ({
    ...state,
    catalogsFilterState: {
      ...state.catalogsFilterState,
      searchCatalogs: action.search
    }
  })),
  // on(EnablePricebooksSuccess, (state, action) => ({
  //   ...state,
  //   catalog: state.catalog ? state.catalog?.deals?.some((deal) => action.ids.includes(deal.id)) ? { ...state.catalog, deals: state.catalog?.deals?.map((deal) => action.ids.includes(deal.id) ? { ...deal, active: true } : deal) } : state.catalog : null
  // })),
  // on(DisablePricebooksSuccess, (state, action) => ({
  //   ...state,
  //   catalog: state.catalog ? state.catalog?.deals?.some((deal) => action.ids.includes(deal.id)) ? { ...state.catalog, deals: state.catalog?.deals?.map((deal) => action.ids.includes(deal.id) ? { ...deal, active: false } : deal) } : state.catalog : null
  // })),
  on(TogglePricebookForCatalogSuccess, (state, action) => ({
    ...state,
    catalog: state.catalog ? { ...state.catalog, deals: state.catalog?.deals?.map((deal) => deal.id === action.pricebookId ? { ...deal, active: !deal.active } : deal) } : null
  })),
  on(catalogsActions.AddPromotionToCatalog, (state, action) => ({
    ...state,
    catalog: state.catalog ? { ...state.catalog, deals: [...state.catalog!.deals!, action.promotion] } : null
  })),
  
  // Catalog Audience reducers
  on(catalogsActions.GetCatalogAudienceSuccess, (state, action) => ({
    ...state,
    audienceCompanies: action.companies,
    audienceMetadata: action.metadata || null,
  })),
  on(catalogsActions.LoadMoreCatalogAudienceSuccess, (state, action) => ({
    ...state,
    audienceCompanies: [...state.audienceCompanies, ...action.companies],
    audienceMetadata: action.metadata || null,
  })),
  on(catalogsActions.ClearCatalogAudience, (state) => ({
    ...state,
    audienceCompanies: [],
    audienceMetadata: null,
  })),
  // Available Companies reducers (for selection dialog)
  on(catalogsActions.GetAvailableCompaniesSuccess, (state, action) => ({
    ...state,
    availableCompanies: action.companies,
    availableCompaniesMetadata: action.metadata || null,
  })),
  on(catalogsActions.LoadMoreAvailableCompaniesSuccess, (state, action) => ({
    ...state,
    availableCompanies: [...state.availableCompanies, ...action.companies],
    availableCompaniesMetadata: action.metadata || null,
  })),
  on(catalogsActions.ClearAvailableCompanies, (state) => ({
    ...state,
    availableCompanies: [],
    availableCompaniesMetadata: null,
  })),
)

export function catalogsReducer(state: CatalogsState | undefined, action: Action) {
  return featureReducer(state, action);
}
